import { css } from "@emotion/react";
import { RiCalendarLine } from "@itandi/itandi-bb-ui";
import { Label } from "@itandi/itandi-bb-ui/Label";
import { formatDate } from "@itandi/tools/vanilla";
import { useState } from "react";
import { Button } from "~/components/common/parts/button/Button";
import {
	TYPE_CLEANING,
	TYPE_MISC_CONSTRUCTION,
	TYPE_RECOVERING_CONSTRUCTION
} from "~/constants/DealConstructionConst";
import type { Deal } from "~/models/Deal";
import type { ConstructionScheduleType } from "~/models/DealConstructionSchedule";
import {
	CONSTRUCTION_SCHEDULE_LABELS,
	getScheduleDisplay
} from "~/models/DealConstructionSchedule";
import { ScheduleInputModal } from "./ScheduleInputModal";
import Styles from "./ScheduleInputNavigation.module.scss";

const constructionNumbers: ConstructionScheduleType[] = [
	TYPE_MISC_CONSTRUCTION,
	TYPE_RECOVERING_CONSTRUCTION,
	TYPE_CLEANING
];

type Props = {
	deal: Deal;
};

export function ScheduleInputNavigation({ deal }: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const schedules = constructionNumbers.map((typeNumber) => ({
		schedule: deal.dealConstructionSchedules.find(
			(s) => s.constructionScheduleType === typeNumber
		),
		typeNumber
	}));
	const hasRegisteredSchedule = schedules.some(
		({ schedule }) => schedule !== undefined
	);

	return (
		<div className={Styles.NavigationBlock}>
			<div className={Styles.IconWrapper}>
				<RiCalendarLine className={Styles.Icon} />
			</div>
			<div className={Styles.NavigationContent}>
				<div>
					<h4 className={Styles.Title}>工事日程を入力してください</h4>
					<div className={Styles.Schedules}>
						{hasRegisteredSchedule ? (
							<>
								{schedules.map(({ typeNumber, schedule }) => (
									<p className={Styles.ScheduleRow} key={typeNumber}>
										{CONSTRUCTION_SCHEDULE_LABELS[typeNumber]}:
										{getScheduleDisplay(schedule).text}
									</p>
								))}
								<p className={Styles.ScheduleRow}>
									<span>完工予定日: </span>
									<span
										css={css({
											fontWeight: deal.constructionEndDate ? "bold" : "normal",
											opacity: deal.constructionEndDate ? 1 : 0.6
										})}
									>
										{formatDate(deal.constructionEndDate, "未定")}
									</span>
								</p>
							</>
						) : (
							<Label color="subtle">日程は登録されていません</Label>
						)}
					</div>
				</div>
				<div className={Styles.DetailLinkBlock}>
					<Button
						className={Styles.DetailLinkButton}
						onClick={() => {
							setIsOpen(true);
						}}
						variant="normal"
					>
						工事日程を入力
					</Button>
					{isOpen ? (
						<ScheduleInputModal
							deal={deal}
							handleClose={() => {
								setIsOpen(false);
							}}
						/>
					) : null}
				</div>
			</div>
		</div>
	);
}
